import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTab } from '../../contexts/TabContext';
import { CurrentTab } from './CurrentTab';
import { InsightsTab } from './InsightsTab';
import { HistoricalTab } from './HistoricalTab';
import { ReportTab } from './ReportTab';

export function TabContent() {
  const { activeTab } = useTab();

  // Scroll to top when tab changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeTab]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, x: 10 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -10 }}
        transition={{ duration: 0.15 }}
        role="tabpanel"
        aria-label={`${activeTab} tab content`}
      >
        {activeTab === 'current' && <CurrentTab />}
        {activeTab === 'insights' && <InsightsTab />}
        {activeTab === 'historical' && <HistoricalTab />}
        {activeTab === 'report' && <ReportTab />}
      </motion.div>
    </AnimatePresence>
  );
}
